import { useCallback } from 'react';
import { reorderArr } from 'common/utils';
import { DropResult } from 'react-beautiful-dnd';

import { TRoutePoint } from '../types/routePoints';
import { TSetRoutePoints } from '../types/setRoutePoints';

const useDragEnd = (setRoutePoints: TSetRoutePoints) => {
  const onDragEnd = useCallback(
    (result: DropResult) => {
      if (result.destination) {
        setRoutePoints((routePoints) =>
          reorderArr<TRoutePoint>(
            routePoints,
            result.source.index,
            result?.destination?.index,
          ),
        );
      }
    },
    [setRoutePoints],
  );

  return onDragEnd;
};

export default useDragEnd;
